import React from 'react';
import { MenuItemType } from '../../../../../ui';
import { PencilIcon, TrashIcon } from '../../../../../ui/icons/icons';
import { Permission } from '../../../../../utils/helpers/permissions';
import { PartnerUser } from '../../../../../utils/types/admin_types';

interface IMenuItemsColumns {
  onEdit: (row: PartnerUser) => void;
  onDelete: (row: PartnerUser) => void;
}

export const getMenuItemsForMenu = ({
  onEdit,
  onDelete,
}: IMenuItemsColumns): MenuItemType<PartnerUser>[] => {
  return [
    {
      label: 'Edit',
      icon: <PencilIcon />,
      permission: [Permission.PARTNER_EDIT],
      onClick: (row) => onEdit(row),
    },
    {
      label: 'Delete',
      icon: <TrashIcon />,
      permission: [Permission.PARTNER_DELETE],
      onClick: (row) => onDelete(row),
    },
  ];
};
